import classes from './TransportForm.module.sass'
import { format } from 'date-fns'
import { Input } from '../../../common/components/input/Input'
import { Textarea } from '../../../common/components/textarea/Textarea'
import { Button } from '../../../common/components/button/Button'
import { FormStage } from '../../../common/types/enums'
import { useTransportForm } from './hooks/useTransportForm'
import { FileUpload } from '../../../common/components/fileUpload/FileUpload'
import { Toggle } from '../../../common/components/toggle/Toggle'
import { PointForm } from '../../../common/components/form/pointForm/PointForm'
import { GMapForRoute } from '../../../common/components/maps/gMapForRoute/GMapForRoute'
import { GMapForMarker } from '../../../common/components/maps/gMapForMarker/GMapForMarker'
import { russiaCenter } from '../../../common/utils/constants'
import { Helmet } from 'react-helmet-async'
import TransportTypeSelector from '../../../common/components/transportTypeSelector/TransportTypeSelector'

export const TransportForm = () => {
  const {
    inputHandler,
    data,
    setData,
    getValidationResult,
    disabled,
    setDirty,
    formStage,
    setFormStage,
    disabled1,
    disabled2,
    formAction,
    files,
    setFiles,
    pairs,
    setPairs,
    addresses,
    setAddresses,
    isRoute,
    setIsRoute,
    edit,
    toggleIntercity,
    editPointsData,
    setTransportTypeValid,
    toggleStartImportant,
    toggleEndImportant,
  } = useTransportForm()

  return (
    <div className={classes.Container} onClick={(e) => e.stopPropagation()}>
      <Helmet>
        <title>{`logid - форма добавления транспорта от фуры до курьера`}</title>
        <meta
          name="description"
          content={`Добавить транспорт от фуры до курьера, найти заказ для транспорта`}
        />
      </Helmet>
      <div className={classes.Title}>{edit ? 'Редактиврование транспорта' : 'Новый транспорт'}</div>

      {formStage === FormStage.ONE && (
        <div className={classes.StageContainer}>
          <div className={classes.Toggles}>
            <TransportTypeSelector
              setTopData={setData}
              setTransportTypeValid={setTransportTypeValid}
              topData={data}
            />
            <div className={classes.ToggleContainer}>
              <Toggle id={'intercity'} onChange={toggleIntercity} checked={data.intercity} />
              <div>Межгород</div>
            </div>

            <div className={classes.ToggleContainer}>
              <Toggle
                id={'isRoute'}
                onChange={() => {
                  setIsRoute((prev) => !prev)
                }}
                checked={isRoute}
              />
              <div>Есть запланированный маршрут</div>
            </div>

            {data.intercity && isRoute && (
              <div className={classes.ToggleContainer}>
                <Toggle
                  id={'addresses'}
                  onChange={() => {
                    setAddresses((prev) => !prev)
                  }}
                  checked={addresses}
                />
                <div>Указывать точные адреса</div>
              </div>
            )}
          </div>

          <Input
            type={'text'}
            fieldName={'name'}
            value={data.name}
            placeHolder={'Название транспорта'}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('name')}
            onBlur={setDirty}
          />

          <Textarea
            type={'textarea'}
            fieldName={'description'}
            value={data.description}
            placeHolder="Опишите транспорт подробно"
            rows={5}
            cols={20}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('description')}
            onBlur={setDirty}
          />

          <Input
            type={'numberText'}
            fieldName={'cost'}
            value={data.cost ? data.cost : ''}
            placeHolder={'Минимальный заказ'}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('cost')}
            onBlur={setDirty}
          />
        </div>
      )}

      {formStage === FormStage.TWO && (
        <div className={classes.StageContainer}>
          <PointForm
            addresses={addresses}
            intercity={Boolean(data.intercity)}
            topData={data}
            setTopData={setData}
            isRoute={isRoute}
            initialData={editPointsData && editPointsData}
          />

          <div className={classes.MapContainer}>
            {isRoute ? (
              <GMapForRoute
                data={data}
                intercity={Boolean(data.intercity)}
                addresses={addresses}
                //@ts-ignore
                setData={setData}
              />
            ) : (
              <GMapForMarker center={russiaCenter} item={data} />
            )}
          </div>
        </div>
      )}

      {formStage === FormStage.THREE && (
        <div className={classes.StageContainer}>
          {isRoute && (
            <div className={classes.TimeContainer}>
              <div className={classes.ToggleContainer}>
                <Toggle
                  id={'start_important'}
                  onChange={toggleStartImportant}
                  checked={data.start_important}
                />
                <div>Указать время начала</div>
              </div>

              {data.start_important && (
                <>
                  <Input
                    label="Время подачи"
                    type="datetime-local"
                    fieldName="startTime"
                    onChangeHandler={inputHandler}
                    value={`${format(new Date(data.startTime), 'yyyy-MM-dd')}T${format(
                      new Date(data.startTime),
                      'HH:mm',
                    )}`}
                  />
                  <div className={classes.ToggleContainer}>
                    <Toggle
                      id={'end_time'}
                      onChange={toggleEndImportant}
                      checked={data.end_important}
                    />
                    <div>Указать время окончания</div>
                  </div>
                </>
              )}
              {data.end_important && (
                <Input
                  label="Время завершения"
                  type="datetime-local"
                  fieldName="endTime"
                  onChangeHandler={inputHandler}
                  value={`${format(new Date(data.endTime), 'yyyy-MM-dd')}T${format(
                    new Date(data.endTime),
                    'HH:mm',
                  )}`}
                />
              )}
            </div>
          )}
          {/* <Regularity /> */}

          <FileUpload
            length={3}
            min_length={1}
            extensions={['jpeg', 'png', 'jpg', 'webp']}
            files={files}
            setFiles={setFiles}
            pairs={pairs}
            setPairs={setPairs}
          />
        </div>
      )}

      <div className={classes.ButtonsContainer}>
        {formStage !== FormStage.ONE && (
          <Button
            text={'Назад'}
            onClick={() => {
              setFormStage((prev) => prev - 1)
              window.scroll(0, 0)
            }}
          />
        )}

        <Button
          text={
            formStage !== FormStage.THREE ? 'Продолжить' : edit ? 'Сохранить' : 'Добавить транспорт'
          }
          disabled={
            (disabled && formStage === FormStage.THREE) ||
            (disabled1 && formStage === FormStage.ONE) ||
            (disabled2 && formStage === FormStage.TWO)
          }
          onClick={() => {
            if (formStage !== FormStage.THREE) {
              setFormStage((prev) => prev + 1)
              window.scroll(0, 0)
            } else formAction()
          }}
        />
      </div>
    </div>
  )
}
